import React from "react";
import Modal from 'react-bootstrap/Modal';
import { useError } from '../../contexts/ErrorContext';

function GlobalErrorModal() {
  const { error, clearError } = useError();

  const handleClose = () => {
    clearError();
  };

  return (
    <Modal
      show={!!error}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
    >    
      <Modal.Header>
        <Modal.Title>
          <h4 className="modal-title">
            <i className="fas fa-ban neo-danger"></i>&nbsp; Error
          </h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span className="error" data-testid="errorMessage">{error}</span>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-cancel" data-testid="closeBtn" onClick={handleClose}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default GlobalErrorModal;

